import styled from "@emotion/styled";
import Button from "@mui/material/Button";

const LargeButton = styled(Button)({
    width: '100%',
    minHeight: '120px',
    maxHeight: '120px'
});

export default LargeButton;